<template>
    <div :class="['reminder-detail-page',{'pb144':reminderData.is_schedule==1&&reminderData.status==1}]">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <headers title="通知详情"></headers>
            <div class="reminder-detail">
                <div class="tips">{{ resultText }}</div>
                <div class="text">
                    <p v-html="reminderData.content"></p>
                </div>
                <div class="audio_line" v-if="reminderData.audio">
                    <div class="audio_icon" @click="playAudio">{{audioText}}</div>
                    <audio ref="audioEle" class="audio_ele" :src="reminderData.audio"></audio>
                </div>
                <div class="img_wrap clearfix" v-if="reminderData.images.length">
                    <div class="img_item" v-for="(img,index) in reminderData.images" :key="index"><img @click="previewImg(index)" :src="img" alt=""></div>
                </div>
            </div>
            <div class="unread_list" v-if="showList">
                <div class="unread_item">
                    <div class="title_text">未读名单</div>
                    <div class="notice_btn" @click="remindAll">提醒全部</div>
                </div>
                <div class="unread_item" v-for="user in reminderData.unread" :key="user.user_id">
                    <div class="user_name">{{user.real_name}}</div>
                    <div class="right_btn">
                        <img class="btn_icon" @click="remindOne(user)" src="../img/lingdang.png" alt="">
                        <img class="btn_icon" @click="callUser(user)" src="../img/telephone.png" alt="">
                    </div>
                </div>
            </div>
            <div class="fix-btm" v-if="reminderData.is_schedule==1&&reminderData.status==1">
                <span @click="cancel">撤销发送</span>
            </div>
            <transition name="fade">
                <div class="tea_cover" @click="clearFn" v-show="actionsheetVisibe"></div>
            </transition>
            <transition name="slide">
                <div class="slide_panel" v-show="actionsheetVisibe">
                    <div class="sheet_list">
                        <div class="sheet_title">
                            <div v-if="remindAllFlag">是否提醒所有未读的家长？</div>
                            <div v-else>要提醒 <span class="orange">{{ remindStu.real_name }}爸妈</span> 查看吗?</div>
                        </div>
                        <div class="sheet_item" v-if="smsRemind" @click="remindUser">同步课堂免费短信提醒</div>
                        <div class="sheet_item" @click="clearFn" v-else><a class="sheet_link" :href="'tel:'+remindStu.phone">{{ remindStu.phone }}</a></div>
                    </div>
                    <button class="calcel_btn" @click="clearFn">取消</button>
                </div>
            </transition>
        </template>
    </div>
</template>

<script>
    import headers from 'COMPONENTS/base/header.vue'
    import loadings from "COMPONENTS/base/loadingS.vue";
    export default {
        components: {
            headers,loadings
        },
        data () {
            return {
                unit_id: this.$route.params.unit_id,
                message_id: this.$route.params.message_id,
                reminderData: {},
                resultText:"",
                loading:true,
                showList:false,
                actionsheetVisibe:false,
                remindStu:{},
                smsRemind:true,
                remindAllFlag:false
            }
        },
        created () {
            this.getDetail()
        },
        computed:{
            audioText(){
                if(this.reminderData.audio_size){
                    let ss = this.reminderData.audio_size % 60;
                    let mm = parseInt(this.reminderData.audio_size / 60);
                    if(ss < 10) ss = "0"+ss
                    if(mm < 10) mm = "0"+mm
                    return mm + ":" + ss
                }else{
                    return "00:00"
                }
            }
        },
        methods: {
            //获取通知详情
            getDetail () {
                let url = API_URL_JXGT_API + '/message/detail'
                let params = {
                    unit_id: this.unit_id,
                    message_id: this.message_id,
                    user_type: 3,
                }
                this.$http.post(url, params).then(res => {
                    if (res.data.response == 'ok') {
                        let data = res.data.data;
                        this.reminderData = data;
                        if(data.method==2){
                            this.resultText = data.status == 4 ? "短信通知已发送" : data.status == 3 ? "已撤销" : "定时发送:" + data.schedule_time;
                        }else{
                            if(data.is_schedule == 1 && data.status == 1){
                                this.resultText = "定时发送:" + data.schedule_time;
                            }else if(data.is_schedule == 1 && data.status == 3){
                                this.resultText = "已撤销";
                            }else{
                                this.resultText = `${data.read_num}人已读,${data.stu_num-data.read_num}人未读`;
                                this.showList = true;
                            }
                        }
                        this.loading = false;
                    }
                })
            },
            playAudio(){
                let audio = this.$refs.audioEle;
                if(audio.paused == true){
                    audio.play()
                }else{
                    audio.pause()
                }
            },
            previewImg(i){
                this.$imagePreview({
                    images: this.reminderData.images,
                    index: i,
                    defaultOpt: {
                        bgOpacity: 1,
                        showHideOpacity: true,
                        errorMsg: '<div class="pswp__error-msg">图片加载失败</div>',
                        tapToClose: true, // 点击上层图层关闭预览
                    }
                });
            },
            remindOne(user){
                this.remindStu = user;
                this.actionsheetVisibe = true;
            },
            remindAll(){
                this.remindAllFlag = true;
                this.actionsheetVisibe = true;
            },
            callUser(user){
                this.remindStu = user;
                this.smsRemind = false;
                this.actionsheetVisibe = true;
            },
            remindUser(){
                let user_ids = "";
                if(this.remindAllFlag){
                    user_ids = this.reminderData.unread.map(user=>user.user_id).join(",");
                }else{
                    user_ids = this.remindStu.user_id;
                }
                this.$http.post(API_URL_JXGT_API + '/message/topic', {
                    "message_id": this.reminderData.id,
                    "place_id":48,
                    "user_id" :user_ids
                }).then(res => {
                    if (res.data.response == 'ok') {
                        layer.tips("发送成功");
                        this.clearFn();
                    }
                })
            },
            clearFn(){
                this.actionsheetVisibe = false;
                let timer = setTimeout(()=>{
                    this.remindStu = {};
                    this.smsRemind = true;
                    this.remindAllFlag = false;
                    clearTimeout(timer);
                },300)
            },
            //撤销
            cancel () {
                let that = this;
                layer.open({
                    title: '撤销发送',
                    content: '确定要撤销发送该通知吗？',
                    diff: 'tea',
                    btn: ['确定', '取消'],
                    yes: function (index) {
                        that.cancelSend()
                        layer.close(index);

                    }
                });
            },
            //撤销发送请求
            cancelSend () {
                if (this.reminderData.is_schedule == 0 || this.reminderData.status != 1) {
                    layer.tips('非定时消息，无法撤销')
                    return
                }
                let url = API_URL_JXGT_API + '/message/remove'
                let params = {
                    unit_id: this.reminderData.unit_id,
                    message_id: this.reminderData.id,
                }
                this.$http.post(url, params).then(res => {
                    if (res.data.response == 'ok') {
                        layer.tips(res.data.message)
                        this.$router.push('/classReminder/index')

                    }

                })
            },

        },
        destroyed () {
            localStorage.removeItem('reminderData')
        }
    }
</script>

<style lang="scss" scoped>
    .reminder-detail-page{
        padding-bottom: 24px/$ppr;
        &.pb144{
            padding-bottom: 144px/$ppr;
        }
        .reminder-detail {
            background: #fff;
            padding: 4px/$ppr 24px/$ppr 0;
            margin-bottom: 24px/$ppr;
            .tips {
                color: #999;
                font-size: 24px/$ppr;
                line-height: 104px/$ppr;
            }
            .text {
                font-size: 30px/$ppr;
                line-height: 52px/$ppr;
                padding-bottom: 34px/$ppr;
                white-space: pre-wrap;
            }
            .audio_line{
                padding-bottom: 46px/$ppr;
                .audio_icon{
                    width: 240px/$ppr;
                    height: 80px/$ppr;
                    background-image: url("../img/audio_icon.png");
                    line-height: 80px/$ppr;
                    background-size: 100% 100%;
                    text-align: center;
                    color: #fff;
                    font-size: 28px/$ppr;
                }
                .audio_ele{
                    width: 0;
                    height: 0;
                    visibility: hidden;
                }
            }
            .img_wrap{
                padding-bottom: 40px/$ppr;
                .img_item{
                    float: left;
                    width: 220px/$ppr;
                    height: 220px/$ppr;
                    position: relative;
                    &:not(:nth-of-type(3n)){
                        margin-right: 6px/$ppr;
                    }
                    img{
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
        .unread_list{
            background-color: #fff;
            .unread_item{
                padding: 0 24px/$ppr;
                height: 96px/$ppr;
                border-bottom: 1px/$ppr solid #eee;
                font-size: 30px/$ppr;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .title_text{
                    font-weight: bold;
                }
                .notice_btn{
                    color: #5e89ef;
                }
                .right_btn{
                    padding-right: 16px/$ppr;
                    .btn_icon{
                        height: 44px/$ppr;
                        &:first-child{
                            margin-right: 80px/$ppr;
                        }
                    }
                }
            }
        }
        .fix-btm {
            position: fixed;
            width: 100%;
            bottom: 0;
            left: 0;
            background: #fff;
            padding: 20px / $ppr;
            text-align: center;
            span {
                background: #5e89ef;
                display: inline-block;
                font-size: 30px / $ppr;
                color: #fff;
                height: 80px / $ppr;
                line-height: 80px / $ppr;
                width: 480px / $ppr;
                border-radius: 80px / $ppr;
            }
        }
        .slide_panel{
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 0 24px/$ppr 24px/$ppr;
            box-sizing: border-box;
            z-index: 10001;
            .sheet_list{
                border-radius: 16px/$ppr;
                background-color: #fff;
                margin-bottom: 24px/$ppr;
                .sheet_title{
                    padding: 16px/$ppr 24px/$ppr;
                    line-height: 54px/$ppr;
                    border-bottom: 1px solid #f6f6f6;
                    font-size: 30px/$ppr;
                    color: #999;
                    .orange{
                        color: #ff5c09;
                    }
                }
                .sheet_item{
                    text-align: center;
                    padding: 16px/$ppr 24px/$ppr;
                    font-size: 32px/$ppr;
                    line-height: 64px/$ppr;
                    border-bottom: 1px/$ppr solid #eee;
                    &:last-child{
                        border-bottom: none;
                    }
                    .sheet_link{
                        color: #323232;
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .calcel_btn{
                border-radius: 16px/$ppr;
                background-color: #fff;
                height: 96px/$ppr;
                text-align: center;
                font-size: 32px/$ppr;
                color: #5e89ef;
                border: none;
                width: 100%;
                display: block;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .slide-enter-active, .slide-leave-active {
        transition: transform .3s;
    }
    .slide-enter, .slide-leave-to {
        transform: translateY(100%);
    }
</style>